import React from 'react';

export function PositiveInteger({ parameters, onChange }) {
  return <></>;
}
